
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexjXfg20vSWiqV3Wel4ayAAWoFt0maAgUV4XGStNqb8sIMeta } from "/vercel/path0/src/pages/index.vue?macro=true";
import { default as cancelpC9qROrV3RGjI_45KXIEgpWQXuENQzIFYwlhUAb9_45OF20Meta } from "/vercel/path0/src/pages/cancel.vue?macro=true";
import { default as sign_45inXgLIyI3Z1x64dbYRHam_45CBo6W__45meosxZq37d0NIjpgMeta } from "/vercel/path0/src/pages/sign-in.vue?macro=true";
import { default as sign_45upmM_Q3sxGO3A_NOa44wbsD9wmjBCOH21qPBnmiESfVhYMeta } from "/vercel/path0/src/pages/sign-up.vue?macro=true";
import { default as successDMTMhx4Mf0VMp1Wx_45IwT7MTr3_45tQjswFzIpvKWh5sHwMeta } from "/vercel/path0/src/pages/success.vue?macro=true";
import { default as eventsfUczkDZLms2TXbAgUPz_45z7s0a3_jHQdLjADBH4tCp1MMeta } from "/vercel/path0/src/pages/my/events.vue?macro=true";
import { default as not_45foundgUBDy7TOb0SQSk1PwIOAvz2ulUY5eYofXkRPmBAgDl4Meta } from "/vercel/path0/src/pages/not-found.vue?macro=true";
import { default as onboarding0GvRkha2gejZ52mxoziMy5D_451XxI4Bg4dP279m7yhNMMeta } from "/vercel/path0/src/pages/onboarding.vue?macro=true";
import { default as _91vanityUrl_93bK30b5zXd8N3p4_451aEqHTQXPSbdHxpzIJoGJhXWMPdUMeta } from "/vercel/path0/src/pages/[vanityUrl].vue?macro=true";
import { default as indexP9MogACCyE0c_yVr2fzPjYcEu38hLRkySVvoBdJ13JQMeta } from "/vercel/path0/src/pages/admin/index.vue?macro=true";
import { default as createSlq5kB9LZNCIolSKY6zLIkv9ztSkQXAlCEDR9fvQvZ4Meta } from "/vercel/path0/src/pages/event/create.vue?macro=true";
import { default as archiveqBTYxffpMzts67_45m8lH_45wUdEf9ajx133oWd6zi2mKz4Meta } from "/vercel/path0/src/pages/event/archive.vue?macro=true";
import { default as exhibitorsDBCjP_XIh8NuJyN5CN3U0cxesuX5yLrIEDmQ3LgjT6YMeta } from "/vercel/path0/src/pages/my/exhibitors.vue?macro=true";
import { default as detailsu5mDWz7d_RwzyiVz9Qv0j46amZXHrjkuOFYHlfaANuYMeta } from "/vercel/path0/src/pages/account/details.vue?macro=true";
import { default as edit0Dbn6mMeCuODB8d_45FWrp8Y621EnUjCDfMgwQAv25L5kMeta } from "/vercel/path0/src/pages/event/[id]/edit.vue?macro=true";
import { default as view1GwsOGVVawtZUYwTqxeDcp1UztsszvZ2RPsKqVU8ab4Meta } from "/vercel/path0/src/pages/event/[id]/view.vue?macro=true";
import { default as enterbLDCEaqoj6m3h36Zs09GAAkEN25HEnrWLojA4QjBKAEMeta } from "/vercel/path0/src/pages/event/[id]/enter.vue?macro=true";
import { default as indexD_V96q9ixrOxtNjHiaFG7yvpZtyMglB4G7Hwsb_45p_FYMeta } from "/vercel/path0/src/pages/event/[id]/index.vue?macro=true";
import { default as impersonateZh_45JFuo7TNLRBjShVBl3jzwVOEwQek_45nXcQhT7zM5XsMeta } from "/vercel/path0/src/pages/admin/impersonate.vue?macro=true";
import { default as cancel53ETCe3N5UMIQaYn_45tSP8O3u9co3yJ2t0oSc7S73UkYMeta } from "/vercel/path0/src/pages/event/[id]/cancel.vue?macro=true";
import { default as idh6MCWnDfaHyHWg4vxbsAL3FfFi1iN_45wgjzy5h5RNxfIMeta } from "/vercel/path0/src/pages/admin/transform/id.vue?macro=true";
import { default as successbKgDLE1_zQR8z8hAP1qSHNaUAJEYLd8jPnjXxH5eig0Meta } from "/vercel/path0/src/pages/event/[id]/success.vue?macro=true";
import { default as historyegYC3W4ZuophS_MxGyhS1qDS_EUqu478EjyflMFz_45igMeta } from "/vercel/path0/src/pages/my/payment/history.vue?macro=true";
import { default as createu831V5yp0oO1XF231XHdZryN1CkC8HIO9M0Rrgq9SPYMeta } from "/vercel/path0/src/pages/event/[id]/show/create.vue?macro=true";
import { default as editEIYAjzsTmT2eKmPNsd85V_45L7CeX_N7aSEKinb7n6zjkMeta } from "/vercel/path0/src/pages/event/[id]/show/[showId]/edit.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/src/pages/index.vue")
  },
  {
    name: "cancel",
    path: "/cancel",
    component: () => import("/vercel/path0/src/pages/cancel.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    component: () => import("/vercel/path0/src/pages/sign-in.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/vercel/path0/src/pages/sign-up.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/vercel/path0/src/pages/success.vue")
  },
  {
    name: "my-events",
    path: "/my/events",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/src/pages/my/events.vue")
  },
  {
    name: "not-found",
    path: "/not-found",
    component: () => import("/vercel/path0/src/pages/not-found.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/src/pages/onboarding.vue")
  },
  {
    name: "vanityUrl",
    path: "/:vanityUrl()",
    component: () => import("/vercel/path0/src/pages/[vanityUrl].vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: {"middleware":["auth","admin"]},
    component: () => import("/vercel/path0/src/pages/admin/index.vue")
  },
  {
    name: "event-create",
    path: "/event/create",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/src/pages/event/create.vue")
  },
  {
    name: "event-archive",
    path: "/event/archive",
    component: () => import("/vercel/path0/src/pages/event/archive.vue")
  },
  {
    name: "my-exhibitors",
    path: "/my/exhibitors",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/src/pages/my/exhibitors.vue")
  },
  {
    name: "account-details",
    path: "/account/details",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/src/pages/account/details.vue")
  },
  {
    name: "event-id-edit",
    path: "/event/:id()/edit",
    meta: {"middleware":["auth","is-editor"]},
    component: () => import("/vercel/path0/src/pages/event/[id]/edit.vue")
  },
  {
    name: "event-id-view",
    path: "/event/:id()/view",
    meta: {"middleware":["is-editor"]},
    component: () => import("/vercel/path0/src/pages/event/[id]/view.vue")
  },
  {
    name: "event-id-enter",
    path: "/event/:id()/enter",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/src/pages/event/[id]/enter.vue")
  },
  {
    name: "event-id",
    path: "/event/:id()",
    component: () => import("/vercel/path0/src/pages/event/[id]/index.vue")
  },
  {
    name: "admin-impersonate",
    path: "/admin/impersonate",
    meta: {"middleware":["auth","admin"]},
    component: () => import("/vercel/path0/src/pages/admin/impersonate.vue")
  },
  {
    name: "event-id-cancel",
    path: "/event/:id()/cancel",
    component: () => import("/vercel/path0/src/pages/event/[id]/cancel.vue")
  },
  {
    name: "admin-transform-id",
    path: "/admin/transform/id",
    meta: {"middleware":["auth","admin"]},
    component: () => import("/vercel/path0/src/pages/admin/transform/id.vue")
  },
  {
    name: "event-id-success",
    path: "/event/:id()/success",
    component: () => import("/vercel/path0/src/pages/event/[id]/success.vue")
  },
  {
    name: "my-payment-history",
    path: "/my/payment/history",
    meta: {"middleware":["auth"]},
    component: () => import("/vercel/path0/src/pages/my/payment/history.vue")
  },
  {
    name: "event-id-show-create",
    path: "/event/:id()/show/create",
    meta: {"middleware":["is-editor"]},
    component: () => import("/vercel/path0/src/pages/event/[id]/show/create.vue")
  },
  {
    name: "event-id-show-showId-edit",
    path: "/event/:id()/show/:showId()/edit",
    meta: {"middleware":["is-editor"]},
    component: () => import("/vercel/path0/src/pages/event/[id]/show/[showId]/edit.vue")
  }
]